import { NavLink } from "react-router-dom";
import "../../../styles/adminDashboard.css";
import {
  CASE_STATUS_LABELS,
  CASE_TYPE_LABELS,
  CATEGORY_LABELS,
  RESOLUTION_LABELS,
  SEVERITY_CLASS,
  SEVERITY_LABELS,
} from "../../../constants/automapTrustSafetyConstants";

export {
  CASE_STATUS_LABELS,
  CASE_TYPE_LABELS,
  CATEGORY_LABELS,
  RESOLUTION_LABELS,
  SEVERITY_CLASS,
  SEVERITY_LABELS,
};

export function TrustSafetyNav({ active }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/trust-safety" },
    { key: "cases", label: "Casos", href: "/admin/trust-safety/cases" },
    { key: "reports", label: "Reportes", href: "/admin/trust-safety/reports" },
    { key: "listings", label: "Listings sospechosos", href: "/admin/trust-safety/listings" },
    { key: "dealers", label: "Dealers", href: "/admin/trust-safety/dealers" },
    { key: "rules", label: "Reglas", href: "/admin/trust-safety/rules" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-CO", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso));
}

export function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmLabel = "Confirmar" }) {
  if (!open) return null;
  return (
    <div className="admin-dialog-backdrop" role="dialog">
      <div className="admin-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="admin-console__header-actions">
          <button type="button" className="admin-btn" onClick={onCancel}>Cancelar</button>
          <button type="button" className="admin-btn admin-btn--primary" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
